export enum INDEXES {
  STUDIES = 'study',
  CLINICAL = 'clinical',
  PARTICIPANT = 'participant',
  FILE = 'file',
  BIOSPECIMEN = 'biospecimen',
  VARIANTS = 'variants',
  VARIANTS_SOMATIC = 'variants_somatic',
  GENES = 'genes',
}

export enum ES_INDEXES {
  VARIANT = 'variant',
  VARIANT_SOMATIC = 'variant_somatic',
}
